module.exports = __webpack_public_path__ + "media/images/heroes/move-57b790f2f08c62239113afbe366038e4.png";